export const formatDate = (timestamp: string, locale: string) =>
  new Date(timestamp).toLocaleDateString(locale, {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });

export const groupChatsByDate = (chats: any[], locale: string) => {
  return chats.reduce((acc: Record<string, any>, chat) => {
    const date = formatDate(chat.createdOn, locale);
    if (!acc[date]) acc[date] = { date, messages: [] };
    acc[date].messages.push(chat);
    return acc;
  }, {});
};
